import React, { useEffect } from 'react';

import Auth0Login from '../components/Auth/Auth0/Auth0Login';
import Auth0LoginCallback from '../components/Auth/Auth0/Auth0LoginCallback';
import Logout from '../components/Auth/Logout';
import LandingPage from '../components/LandingPage/LandingPage';
import MobileOAuthBridge from '../components/MobileOAuthBridge/MobileOAuthBridge';
import UberEatsOAuthCallbackPage from '../components/OAuth/UberEatsOAuthCallbackPage';
import SelfServeRoutes from '../components/SelfServe/SelfServe.routes';
import AcceptInvitation from '../components/Teammates/Invitation/AcceptInvitation';
import { isMobileDevice } from '../helpers/utilities';
import { accountRoutePaths, externalSupportUrl } from './accountRoutePaths';

export const accountRoutesConst = accountRoutePaths;

const SupportLoginRedirect = () => {
  if (isMobileDevice()) {
    window.location.replace(externalSupportUrl);
    return null;
  }

  const redirectUrl = encodeURIComponent(window.location.href);

  return <Auth0LoginRedirect redirectUrl={redirectUrl} />;
};

const Auth0LoginRedirect = ({ redirectUrl }: { redirectUrl: string }) => {
  useEffect(() => {
    window.location.replace(`${accountRoutesConst.Login}?redirectUrl=${redirectUrl}`);
  }, [redirectUrl]);

  return null;
};

export const publicRoutes: (RoutePropsExtended | RedirectPropsExtended)[] = [
  {
    name: 'accept_invitation',
    group: 'publicAndPrivate',
    path: accountRoutesConst.AcceptInvitation,
    component: AcceptInvitation,
    exact: true,
  },
  {
    name: 'auth.login',
    group: 'public',
    path: accountRoutesConst.Login,
    component: Auth0Login,
    exact: true,
  },
  {
    name: 'auth.auth0login',
    group: 'public',
    path: accountRoutesConst.Auth0Login,
    component: Auth0Login,
    exact: true,
  },
  {
    name: 'auth.auth0logincallback',
    group: 'public',
    path: accountRoutesConst.Auth0LoginCallback,
    component: Auth0LoginCallback,
    exact: true,
  },
  {
    name: 'auth.uber_eats_oauth_callback',
    group: 'private',
    path: accountRoutesConst.UberEatsOAuthCallback,
    component: UberEatsOAuthCallbackPage,
    exact: true,
  },
  {
    name: 'auth.mobile_google_business_oauth_bridge',
    group: 'publicAndPrivate',
    path: accountRoutesConst.MobileGoogleBusinessOAuthBridge,
    component: MobileOAuthBridge,
    exact: true,
  },
  {
    name: 'auth.mobile_stripe_connect_oauth_bridge',
    group: 'publicAndPrivate',
    path: accountRoutesConst.MobileStripeConnectOAuthBridge,
    component: MobileOAuthBridge,
    exact: true,
  },
  {
    name: 'auth.signup',
    group: 'public',
    path: accountRoutesConst.Signup,
    component: Auth0Login,
    exact: true,
  },
  {
    name: 'subscriptions.self_serve',
    group: 'public',
    path: accountRoutesConst.SubscriptionsSelfServeMicroFrontend,
    component: SelfServeRoutes,
    exact: false,
  },
  {
    name: 'support',
    group: 'public',
    path: accountRoutesConst.Support,
    component: SupportLoginRedirect,
    exact: true,
  },
  {
    name: 'landing',
    group: 'public',
    path: accountRoutesConst.Landing,
    component: LandingPage,
    exact: true,
  },
  {
    name: 'auth.redirect_index',
    group: 'public',
    path: '*',
    to: accountRoutesConst.Login,
  },
  {
    name: 'auth.logout',
    group: 'publicAndPrivate',
    path: accountRoutesConst.Logout,
    component: Logout,
    exact: true,
  },
];
